import React, { useEffect, useState } from "react";
import { Close } from "@material-ui/icons";
import { FORM_TYPES } from "common/utils/formUtility";
import { useSelector } from "react-redux";
import * as R from "ramda";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  makeStyles,
  useTheme,
  useMediaQuery,
  Divider,
} from "@material-ui/core";
import { saveSubject } from "components/master/utils";
import { getDetailsById } from "components/listOfValues/utils";
import ManageSubjectForm from "../Subjects/ManageSubjectForm";

const useStyles = makeStyles((theme) => ({
  cardWrapper: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  annualPlanCard: {
    marginBottom: "30px",
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "end",
  },
  heading: {
    fontWeight: 800,
    fontSize: "18px",
    color: "#263657",
  },
  divider: {
    margin: "0 24px 24px 24px",
  },
}));

function ManageSubjectModal(props) {
  const {
    userRoles,
    setModalState,
    modalState,
    parentState,
    getClassesDetails,
  } = props;
  const classes = useStyles();
  const theme = useTheme();
  const isSmallDevice = useMediaQuery(theme.breakpoints.down("sm"));

  const [state, setState] = useState({
    // grade: {},
    subjectValue: "",
    // subjectType: "",
  });
  const isEditForm = modalState.isEdit || false;

  useEffect(() => {
    const { data } = modalState;
    if (isEditForm && data?.id) {
      getSubjectDetails(data.id);
    }
  }, [isEditForm]);

  const getSubjectDetails = async (id) => {
    const response = await getDetailsById("/classes", id);
    const responseData = {
      ...response,
      gradeName: response?.curriculumContext?.gradeName || "",
      subject: {
        value: response.curriculumContext?.subjectValue || "",
        name: response.curriculumContext?.subjectName || "",
      },
    };
    setState(responseData || null);
  };

  const handleClose = () => {
    setModalState((prev) => ({
      isSubjectModalOpen: false,
      data: null,
      isEdit: false,
    }));
  };

  const handleChange = (check, value) => {
    setState((prev) => ({
      ...prev,
      [check]: value,
    }));
  };

  const manageSubjectFormData = useSelector(
    (state) => state.globalForm[FORM_TYPES.MANAGE_SUBJECT]
  );

  const AllowedRoles = ["System Administrator", "Administrator"];

  const isEditEnabled = (roles) => {
    let editEnabled = false;
    if (roles && roles.length > 0) {
      roles.forEach((role) => {
        if (R.includes(role, AllowedRoles)) {
          editEnabled = true;
        }
      });
    }
    return editEnabled;
  };

  const isReadOnly = isEditEnabled(userRoles)
    ? false
    : R.propOr("", "status", manageSubjectFormData) === "COMPLETED";

  const handleSubmit = async () => {
    const postPayload = {
      grade: parentState,
      subjectName: state.subject.name,
      subjectValue: state.subject.value,
      subjectType: state.subjectType,
    };
    const payload = await saveSubject(postPayload, parentState.id); // not sure about utils name here
    // const response = await onAddValue(payload, PAGES.subjects);
    setModalState({
      isSubjectModalOpen: false,
      isEdit: false,
      data: null,
    });
    getClassesDetails && getClassesDetails();
  };

  return (
    <Dialog
      maxWidth="md"
      fullWidth
      open={true}
      fullScreen={isSmallDevice}
      onClose={() =>
        setModalState((prev) => ({
          ...prev,
          isSubjectModalOpen: false,
        }))
      }
      ariaLabeledBy="form-dialog-title"
    >
      <Grid container>
        <Grid item xs={11}>
          <DialogTitle id="form-dialog-title">
            <Typography variant="h6" className={classes.heading}>{`${
              isEditForm ? "Edit" : "Add"
            } Subject`}</Typography>
          </DialogTitle>
        </Grid>
        <Grid item xs={1} className={classes.modalCloseBtn}>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </Grid>
      </Grid>
      <Divider className={classes.divider} />
      <DialogContent style={{ padding: "8px 25px" }}>
        <Box>
          <ManageSubjectForm
            formType={FORM_TYPES.MANAGE_SUBJECT}
            isEditForm={isEditForm}
            isReadOnly={isReadOnly}
            state={parentState}
            handleChange={handleChange}
            disableSubjects={parentState.subjects.map(
              (subject) => subject.subjectValue
            )}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "end",
              pt: 2,
            }}
          >
            <Button
              color="primary"
              // disabled={isReadOnly || isNew}
              variant="contained"
              onClick={handleSubmit}
              data-html2canvas-ignore
            >
              Submit
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default ManageSubjectModal;
